import { apiGet, apiPost, apiPut, apiDelete } from "../api/http";

export interface MyActivityTaskDto {
  taskId?: number;
  taskDate: string;
  comments: string;
    hours: string;
    status:string;
}

export const benchActivityService = {
  // Add a new bench activity task
  addTask: async (engagementId: number, task: MyActivityTaskDto) => {
    return apiPost("/BenchActivityTasks", {
      EngagementID: engagementId,
      TaskDate: task.taskDate
        ? (typeof task.taskDate === 'string'
            ? task.taskDate
            : (task.taskDate as any).format
              ? (task.taskDate as any).format('YYYY-MM-DD')
              : String(task.taskDate))
        : null,
      Comments: task.comments,
      Hours: parseFloat(task.hours),
        CreatedBy: window.localStorage.getItem("userEmail") || "system",
        status: task.status
    });
  },

  // Update an existing bench activity task
  updateTask: async (
    taskId: number,
    engagementId: number,
    task: MyActivityTaskDto
  ) => {
    return apiPut(`/BenchActivityTasks/${taskId}`, {
      TaskID: taskId,
      EngagementID: engagementId,
      TaskDate: task.taskDate
        ? (typeof task.taskDate === 'string'
            ? task.taskDate
            : (task.taskDate as any).format
              ? (task.taskDate as any).format('YYYY-MM-DD')
              : String(task.taskDate))
        : null,
      Comments: task.comments,
      Hours: parseFloat(task.hours),
        ModifiedBy: window.localStorage.getItem("userEmail") || "system",
        status: task.status
    });
  },

  // Delete a bench activity task
  deleteTask: async (taskId: number) => {
    return apiDelete(`/BenchActivityTasks/${taskId}`);
  },

  // Fetch all tasks for an engagement
  getTasksByEngagementId: async (engagementId: number) => {
    return apiGet(`/BenchActivityTasks/by-engagement/${engagementId}`);
  },

  // Update main activity
  updateMainActivity: async ({
    engagementId,
    activityId,
    name,
    description,
    status,
    endDate,
    startDate,
    totalHours,
  }: {
    engagementId: number;
    activityId:number;
    name:string;
    description:string;
    status: string;
    endDate: string;
    startDate: string;
    totalHours: number;
  }) => {
    return apiPut(`/my-activity/${activityId}`, {
    Name: name,
    Description: description,
    Status: status,
    EndDate: endDate ? new Date(endDate).toISOString() : null,
    StartDate: startDate ? new Date(startDate).toISOString() : null,
    TotalHours: totalHours,
  });
    },

    completeActivity: async (activityId: number) => {
        return apiPost(`/my-activity/CompleteActive/${activityId}`, {});
    },
};